import type { LocalizedDict } from '../index'

// Admin Settings → Brand → Login screen
// (features/admin/LoginExperienceSettings.tsx).

export type LoginExperienceStrings = {
  loading: string
  loadError: string
  eyebrow: string
  title: string
  description: string
  publishIndependently: string
  publishError: string
  restoreConfirm: (surface: 'app' | 'admin') => string
}

export const loginExperienceI18n: LocalizedDict<LoginExperienceStrings> = {
  en: {
    loading: 'Loading Login Experience…',
    loadError: 'Login Experience could not be loaded.',
    eyebrow: 'Platform presentation',
    title: 'Login Experience',
    description:
      'Manage the two public login hero images without changing authentication, copy, typography, or access rules.',
    publishIndependently: 'App and Admin publish independently',
    publishError: 'The change could not be published.',
    restoreConfirm: (surface) =>
      `Restore the bundled ${surface === 'app' ? 'App' : 'Admin'} login image?`,
  },
  tr: {
    loading: 'Giriş ekranı yükleniyor…',
    loadError: 'Giriş ekranı yüklenemedi.',
    eyebrow: 'Platform görünümü',
    title: 'Giriş Ekranı',
    description:
      'İki herkese açık giriş ekranı görselini yönet; kimlik doğrulama, metinler, yazı tipleri ve erişim kuralları değişmez.',
    publishIndependently: 'Uygulama ve Admin ayrı ayrı yayınlanır',
    publishError: 'Değişiklik yayınlanamadı.',
    restoreConfirm: (surface) =>
      `Varsayılan ${surface === 'app' ? 'Uygulama' : 'Admin'} giriş görseli geri yüklensin mi?`,
  },
}
